// Module
var code = `<div ng-transclude="tabla"></div> <div class="rrTable"> <div ng-transclude="cabecera" class="rrTableRow"></div> <div ng-repeat="\$f in \$ctrl.editor.filas" ng-transclude="fila" class="rrTableRow glyphaction" ng-click="\$ctrl.edita()"></div> </div> `;
// Exports
module.exports = code;